<template>
    <div>
        <el-table
                ref="classHourMultipleTable"
                :data="$parent.orderCartClassHours"
                size="medium"
                v-show="$parent.classHourClick"
                :height="($parent.$parentInfo.clientHeight-600+$parent.$parentInfo.heightChange)/$parent.row-$parent.cartTypeHeight"
                style="width: 100%"
                @selection-change="handleClassHourSelectionChange">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="semester_name"
                    label="学期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="grade_name"
                    label="年级"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="time"
                    label="时长"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="unit_period_price"
                    label="单价"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="period"
                    label="购买课次"
                    width="80">
            </el-table-column>
            <el-table-column
                    label="折扣"
                    width="80">
                <template slot-scope="scope"><span :style="{'color':scope.row.color}">{{ scope.row.discount }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="总价"
                    prop="sum_price"
                    width="120">
            </el-table-column>
            <el-table-column
                    label="操作">
                <template slot-scope="scope">
                    <el-dropdown trigger="click" size="medium">
                        <el-button icon="el-icon-edit" style="margin-right: 10px"> 编辑</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleDiscountClassHour(scope.row)">优惠信息</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button icon="el-icon-delete" @click="handleDeleteCartClassHour(scope.row.id)"
                               :loading="$parent.$parentInfo.studentCart.button_loading">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "ClassHourCart",
        data() {
            return {

            }
        },
        computed: {

        },
        created() {

        },
        methods: {
            handleClassHourSelectionChange(val){
                this.$parent.classHourMultipleSelection = val;
                let arr = [];
                for (let i in this.$parent.classHourMultipleSelection) {
                    arr.push(this.$parent.classHourMultipleSelection[i].id);
                }
                this.$parent.$parentInfo.studentCart.chosenClassHourCart = arr;
            },
            handleDiscountClassHour(cart_classHour){
                this.$parent.$parentInfo.studentCart.dialog_DiscountClassHour.discountFilter.discount=cart_classHour.discount
                this.$Win.openModal('Dialog_DiscountClassHour', 450, 400, '优惠', {
                    'cart_classHour_id': cart_classHour.id
                });
            },
            handleDeleteCartClassHour(id){
                this.$confirm('移除后将失去已设定的优惠信息，确定移除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parent.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parent.$parentInfo.path, 'delete_classHour_to_cart', {
                        'student_id': this.$parent.$parentInfo.student_id,
                        'cart_classHour_id': id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }

    }
</script>

<style scoped>

</style>